/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { LuiSearch } from '@jda/lui-common-component-library-mui5';

import { useStyles } from './styles';
import { ICustomSearch } from '../../models/Common/CustomSearch';

const CustomSearch = ({ placeHolder, value, onSearchChange, onClearInput, size }: ICustomSearch) => {
  const [searchValue, setSearchValue] = useState('');
  const { classes } = useStyles();

  useEffect(() => {
    if (!searchValue) {
      setSearchValue(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (event: any) => {
    setSearchValue(event.currentTarget.value);
    let value = event.currentTarget.value;
    if (value && value.length >= 3) {
      onSearchChange(value);
    } else {
      onSearchChange('');
    }
  };
  const handleClear = () => {
    setSearchValue('');
    onSearchChange('');
    onClearInput && onClearInput()
  };

  return (
    <Box>
      <LuiSearch
        id="custom-search-bar"
        value={searchValue}
        onChange={handleChange}
        onClear={handleClear}
        placeholder={placeHolder}
        className={classes.searchTextBox}
        size={size || 'small'}
        inputProps={{
          minLength: 3,
          maxLength: 40,
          className: 'customsearchInput',
          autoComplete: "off"
        }}
      />
    </Box>
  );
};

export default CustomSearch;
